import 'css-chunksrc/client/pages/costProfilesPage/sidebar/costProfiles/styles.scss';export default {
  "costProfile": "_costProfile_24xnm_1"
};